import styled from "styled-components"

import { minWidth, eq } from "utils"

import Icon from "icons"

export const Container = styled.div`
`

export const Items = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
`

export const Item = styled.div`
  flex: 1 1 48%;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: 1.2rem;
`

export const Key = styled.div`
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.6rem;
  letter-spacing: 0.2rem;
  text-transform: uppercase;
`

export const Value = styled.div`
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 2.5rem;
`

export const SeeAllSpecs = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.2rem;
  padding-top: 1.2rem;
`

export const Line = styled.div`
  width: 100%;
  height: 0.1rem;
  background-color: #22222233;
`

export const TextAndArrow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.35rem;
  letter-spacing: 0.1rem;
  cursor: pointer;
  white-space: nowrap;
`

export const Arrow = styled(Icon)`
  padding: 1rem;
  color: #000;

  ${eq("orientation", "down")`
    transform: rotate(-90deg);
  `}

  ${eq("orientation", "up")`
    transform: rotate(90deg);
  `}
`
